import React, { useRef } from "react";
import "./TodoList.css";
import TasksHeader from "../../TasksHeader/TasksHeader";
import CalendarTaskCard from "../CalendarTaskCard/CalendarTaskCard";
import { handleTaskNameClick } from "../../helper/helper";
import TastStatus from "../../TastStatus/TastStatus";

const TodoList = ({ todos = [] }) => {
  const ref = useRef();
  if (todos.length === 0) return;
  return (
    <div className="todo-list" role="todo-list">
      <TasksHeader todos={todos.length} refObj={ref}>
        <div className="list-container" ref={ref}>
          {todos.map((todo) => (
            <div
              onClick={() => handleTaskNameClick(todo)}
            >
              <TastStatus event={todo} />
              {<CalendarTaskCard event={todo} />}
            </div>
          ))}
        </div>
      </TasksHeader>
    </div>
  );
};

export default TodoList;
